module.exports = __webpack_public_path__ + "img/41.not_good.6751ffbd.svg";